import { useEffect, useState } from "react";
import { navItems, siteName } from "@/mocks/heiliaoHome";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 8);
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-colors duration-300 border-b ${
        scrolled ? "bg-background-50/95 border-background-200/70 backdrop-blur" : "bg-transparent border-transparent"
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="mx-auto max-w-[1280px] flex items-center justify-between h-16 md:h-[72px] gap-4">
          {/* logo */}
          <a href="#" onClick={(e) => e.preventDefault()} className="flex items-center gap-2.5 cursor-pointer group">
            <span className="grid place-items-center h-9 w-9 rounded-lg bg-primary-500 text-background-50 group-hover:bg-primary-600 transition-colors">
              <i className="ri-skull-2-fill text-lg"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-serif text-lg md:text-xl font-black tracking-wide text-foreground-950 whitespace-nowrap">
                1黑料网
              </span>
              <span className="text-[10px] md:text-[11px] text-foreground-500 tracking-widest mt-0.5 whitespace-nowrap">
                导航 · 入口 · 直达
              </span>
            </span>
          </a>

          {/* desktop nav */}
          <div className="hidden lg:flex items-center gap-1 rounded-full bg-background-100/80 p-1">
            {navItems.map((item) => (
              <a
                key={item.label}
                href="#"
                onClick={(e) => e.preventDefault()}
                className={`whitespace-nowrap flex items-center gap-1.5 rounded-full px-4 py-2 text-sm font-medium transition-colors cursor-pointer ${
                  item.active
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-700 hover:text-primary-700 hover:bg-background-200/60"
                }`}
              >
                <i className={`${item.icon} text-[15px]`}></i>
                {item.label}
              </a>
            ))}
          </div>

          {/* right actions */}
          <div className="flex items-center gap-2">
            <a
              href="#"
              onClick={(e) => e.preventDefault()}
              className="hidden md:inline-flex items-center gap-2 rounded-md border border-background-300/70 bg-background-50 px-3.5 py-2 text-sm text-foreground-600 hover:text-primary-700 hover:border-primary-300 transition-colors cursor-pointer"
            >
              <i className="ri-search-line text-base"></i>
              <span className="text-foreground-400">搜瓜 / 找地址</span>
            </a>
            <a
              href="#"
              onClick={(e) => e.preventDefault()}
              className="whitespace-nowrap inline-flex items-center gap-1.5 rounded-md bg-primary-500 text-background-50 px-4 py-2 text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-edit-2-line text-base"></i>
              发帖开瓜
            </a>
            {/* hamburger */}
            <button
              aria-label="菜单"
              onClick={() => setOpen((v) => !v)}
              className="lg:hidden grid place-items-center h-10 w-10 rounded-md text-foreground-800 hover:bg-background-100 cursor-pointer"
            >
              <i className={open ? "ri-close-line text-2xl" : "ri-menu-3-line text-2xl"}></i>
            </button>
          </div>
        </div>

        {/* mobile menu */}
        {open && (
          <div className="lg:hidden border-t border-background-200/70 bg-background-50 px-2 py-3">
            <div className="grid grid-cols-2 gap-2">
              {navItems.map((item) => (
                <a
                  key={item.label}
                  href="#"
                  onClick={(e) => e.preventDefault()}
                  className={`flex items-center gap-2 rounded-md px-3 py-2.5 text-sm font-medium transition-colors cursor-pointer ${
                    item.active ? "bg-primary-100 text-primary-700" : "text-foreground-700 hover:bg-background-100"
                  }`}
                >
                  <i className={`${item.icon} text-base`}></i>
                  {item.label}
                </a>
              ))}
            </div>
          </div>
        )}
      </nav>
      <span className="sr-only">{siteName}</span>
    </header>
  );
}